import { axiosGet } from 'shared/api/axios'
import { apiUrls, attFormats, reportHeights } from 'consts'
import ActionButtons from 'shared/components/ActionButtons'

interface getRowsProps {
  setDeleteEntryId: Function
  setShowModal: Function
  filter?: object
}

const getRows = async (props: getRowsProps) => {
  const getParams = {}

  //TODO getParams cannot be passed here when you remove data from the table
  const response = await axiosGet(apiUrls.reports, getParams)

  const data = response.data

  data.forEach((row: any, index: number, dataArray: any) => {
    dataArray[index].action = (
      <ActionButtons
        buttons={[
          {
            type: 'u',
            url: '/edit-report/' + row.id,
          },
          {
            type: 'd',
            id: dataArray[index].id,
            url: '/delete-report/' + row.id,
            setDeleteEntryId: props.setDeleteEntryId,
            setShowModal: props.setShowModal,
          },
        ]}
      />
    )
    const attFormatsSelected: Array<string> = []

    row.formats.forEach((fmtSelected) => {
      const attFmtObj: { id: string; name: string } | undefined = attFormats.find(
        (f) => f.id === fmtSelected,
      )
      if (attFmtObj !== undefined) {
        attFormatsSelected.push(attFmtObj.name)
      }
    })

    dataArray[index].formats = attFormatsSelected
      .sort((a, b) => a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' }))
      .join(', ')
    dataArray[index].active = dataArray[index].active === 1 ? 'Yes' : 'No'
    dataArray[index].height = reportHeights.find((h) => h.id === dataArray[index].height)?.name
  })

  return data
}

export default getRows
